<div class="container">
  <div class="card offset xp">
    <h1 class="mb-0">Service Requests</h1>
    <div class="my-4"><a routerLink="/program"
        class="icon-btn fa-chevron-left">
        {{ serviceRequestLabel.SERVICE_REQUEST_PROGRAM_INFO_LINK }}</a></div>
    <div class="d-flex mb-4"
      *ngIf="showAddNewWCPRequest">
      <a routerLink="/program/add-new-wc-posting-request"
        class="icon-btn-right fa-chevron-right">
        {{serviceRequestLabel.SERVICE_WC_REQUEST_ADD_NEW}}</a>
    </div>

    <lib-tabs>
      <lib-tab tabTitle={{serviceRequestLabel.OUTSTANDING_HEADING}}>
        <div class="mt-3 mb-5">

          <ag-grid-angular style="width: 100%; height: 100%;"
            [rowData]="outstandingTableData"
            [columnDefs]="outstandingColumnDefs"
            [defaultColDef]="defaultColDef"
            [enableCellTextSelection]="true"
            [suppressRowClickSelection]="true"
            [suppressCellFocus]="true"
            [pagination]="totalRowsOutstanding > 10"
            class="ag-theme-quartz"
            (gridReady)="onGridReadyOutstanding($event)"
            [paginationPageSize]="paginationPageSizeOutstanding"
            [paginationPageSizeSelector]="paginationPageSizeSelectorOutstanding"
            overlayNoRowsTemplate="<span></span>"></ag-grid-angular>
          <div>
            <div class="text-center font-weight-bold"
              *ngIf="outstandingTableData.length === 0">No Outstanding Service
              Requests</div>
          </div>
          <div>
            <div class="bg-primary text-white px-2">Outstanding Requests: {{outstandingTableData.length}}</div>
          </div>
        </div>
      </lib-tab>

      <lib-tab tabTitle={{serviceRequestLabel.COMPLETED_HEADING}}>
        <div class="mt-3 mb-5">
          <ag-grid-angular style="width: 100%; height: 100%;"
            [rowData]="completedTableData"
            [columnDefs]="completedColumnDefs"
            [defaultColDef]="defaultColDef"
            [enableCellTextSelection]="true"
            [suppressRowClickSelection]="true"
            [suppressCellFocus]="true"
            [pagination]="totalRowsCompleted > 10"
            class="ag-theme-quartz"
            (gridReady)="onGridReadyCompleted($event)"
            [paginationPageSize]="paginationPageSizeCompleted"
            [paginationPageSizeSelector]="paginationPageSizeSelectorCompleted"
            overlayNoRowsTemplate="<span></span>"></ag-grid-angular>
          <div>
            <div class="text-center font-weight-bold"
              *ngIf="completedTableData.length === 0">No Completed Service
              Requests</div>
          </div>
          <div>
            <div class="bg-primary text-white px-2">Completed Requests: {{completedTableData.length}}</div>
          </div>
        </div>

      </lib-tab>
      <lib-tab tabTitle={{serviceRequestLabel.CANCELLED_HEADING}}>
        <div class="mt-3 mb-5">
          <ag-grid-angular style="width: 100%; height: 100%;"
            [rowData]="cancelledTableData"
            [columnDefs]="cancelledColumnDefs"
            [defaultColDef]="defaultColDef"
            [enableCellTextSelection]="true"
            [suppressRowClickSelection]="true"
            [suppressCellFocus]="true"
            [pagination]="totalRowsCancelled > 10"
            class="ag-theme-quartz"
            (gridReady)="onGridReadyCancelled($event)"
            [paginationPageSize]="paginationPageSizeCancelled"
            [paginationPageSizeSelector]="paginationPageSizeSelectorCancelled"
            overlayNoRowsTemplate="<span></span>"></ag-grid-angular>
          <div>
            <div class="text-center font-weight-bold"
              *ngIf="cancelledTableData.length === 0">No Cancelled Service
              Requests</div>
          </div>
          <div>
            <div class="bg-primary text-white px-2">Cancelled Requests: {{cancelledTableData.length}}</div>
          </div>
        </div>
      </lib-tab>
    </lib-tabs>
  </div>
</div>